"use client"
import {
  useWindowSize 
} from "@/common/hooks/useWindowSize";
import mobileDeviceScreenWidth from "@/constants/mobileDeviceScreenWidth";
import {
  useEventingContext 
} from "@/context/eventing";
import {
  useUserContext 
} from "@/context/user";
import {
  useChangeSearchParams 
} from "@/hooks/useChangeSearchParams";
import copy from "clipboard-copy";
import Image from "next/image";
import {
  useRouter 
} from "next/navigation";
import {
  useRef 
} from "react";
import {
  useGetCustmerDetail 
} from "./useGetCustmerDetail";
import {
  useGetReferAFriendConfig 
} from "./useGetReferAFriendConfig";

import {
  useToasts 
} from "@/hooks/Toasts/useToasts";


function ReferAFriendPage(props) {
  const isMobile = useWindowSize().innerWidth < mobileDeviceScreenWidth
  const baseurl = "/refer-a-friend"
  const [, {
    dispatch 
  }] = useEventingContext()
  const userState = useUserContext()

  const {
    paramsObj, setParamsObj 
  } = useChangeSearchParams()

  const placeholderRef = useRef(null)

  const handleClick = () => {
    if (placeholderRef.current) {
      placeholderRef.current.scrollIntoView({
        behavior: "smooth", block: "start" 
      });
    }
  };

  const [{
    isSignedIn, isAuthDialogShow, currentUser 
  }, {
    actions: {
      toggleShowAuthDialog, toggleCurrentAuthDialog 
    } 
  }] = userState


  const {
    firstname 
  } = currentUser || {}

  const handleClose = () => {
    dispatch(toggleShowAuthDialog(false))
  }

  const handleOpen = () => {
    setParamsObj({
      ...paramsObj, loginAfterSubmit: "none" 
    })

    dispatch(toggleShowAuthDialog(true))
    dispatch(toggleCurrentAuthDialog("SIGN_IN"))
  }

  const handleOpenCreateAccount = () => {
    setParamsObj({
      ...paramsObj, loginAfterSubmit: "none" 
    })


    dispatch(toggleShowAuthDialog(true))
    dispatch(toggleCurrentAuthDialog("CREATE_ACCOUNT"))
  }

  const {
    loading,
    error,
    enable_mode,
    enable_reward_by_order,
    reward_type,
    reward_amount,
    refer_reward_type,
    refer_reward_amount,
    minimum_cart_value
  } = useGetReferAFriendConfig()

  const {
    loading: couponCodesLoading,
    error: couponCodesError,
    couponCodes: couponCodesArray
  } = useGetCustmerDetail()


  const mainData = [{
    image: `${baseurl}/work1.png?v=2.0.0`,
    image_m: `${baseurl}/work1_m.png?v=2.0.0`,
    content: <p className='font-urw-din-medium lg_text-[18px] text-primary w-[945px] text-sm leading-[25px]'>
            1.Invite people you know to <span className='font-bold'>sign up</span> for HISEA by sharing your referral link.
            You can find your referral link in <span className='font-bold'>“My Account”</span>.
    </p>
  }, {
    image: `${baseurl}/work2.png?v=2.0.0`,
    image_m: `${baseurl}/work2_m.png?v=5.9.0`,
    content: <p className='font-urw-din-medium lg_text-[18px] text-primary w-[945px] text-sm leading-[25px]'>
            2.Your friend <span className='font-bold'>sign up</span> and have the <span className='font-bold'>first purchase with {reward_amount}% off</span> welcome discount on website.
    </p>
  }, {
    image: `${baseurl}/work3.png?v=2.0.0`,
    image_m: `${baseurl}/work3_m.png?v=2.0.0`,
    content: <p className='font-urw-din-medium lg_text-[18px] text-primary w-[945px] text-sm leading-[25px]'>
            3. Earn  <span className='font-bold'>{`${refer_reward_amount}% off`}</span> reward once your friend completes the first order of the website.
    </p>
  }]

  function MainPC() {
    return <div className='mt-[30px]'>
      {mainData.map((item, index) => {
        return <div className='flex justify-between gap-[80px]' key={index}>
          <div className='border-r-1 border-primary relative border-solid pb-[50px] pr-[80px]'>
            <Image
              src={item.image}
              width={283}
              height={200}
              alt='Refer a Friend'
            />
            <div
              className='bg-primary absolute right-[-5px] top-0 h-[10px] w-[10px] rounded-full'
            />
          </div>

          {item.content}
        </div>
      })}
    </div>
  }

  function MainMobile() {
    return <div>
      <ul className='mt-[15px] flex flex-col gap-[30px]'>
        {mainData.map((item, index) => {
          return <li key={index}>
            <Image
              src={item.image_m}
              width={343}
              height={180}
              alt='Refer a Friend'
              className='mx-auto w-full'
            />
            <div className='mt-[15px] flex gap-[15px]'>
              <div className='font-oswald-bold text-[32px] leading-[32px] text-[#1f6089]'>
                {`0${index + 1}`}
              </div>
              {item.content}
            </div>
          </li>
        })}
      </ul>
    </div>
  }

  function BannerPC() {
    return <div className='relative'>
      <Image
        src={`${baseurl}/banner.webp?v=1.0.0`}
        width={1920}
        height={795}
        alt='Refer a Friend'
        className='mx-auto w-full max-w-[1920px]'
      />

      <div
        className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-center'
      >
        <div className='font-oswald-bold text-[44px] text-white'>
                    Refer A Friend, Get Rewards
        </div>
        <div className='font-urw-din-medium mt-[10px] text-[22px] font-[500] text-white'>
                    Enjoy Win-Win Program!
        </div>
        {isSignedIn ? <div>
          <p className='font-oswald-bold mt-[60px] text-[30px] text-white'>
                        Welcome Back, {firstname || "Customer"}
          </p>

          <p className='mt-[10px] text-white '>
                        Quick Action:  <span onClick={handleClick} className='cursor-pointer text-white underline'>My Reward Codes</span>
          </p>
        </div> : <div className='mt-[60px] flex justify-between gap-[30px]'>
          <button
            className='bg-primary font-oswald-bold h-[70px] w-[300px] text-center text-[18px] leading-[70px] text-white shadow-xl'
            onClick={handleOpenCreateAccount}
          >
                        JOIN NOW!
          </button>

          <button
            className='text-primary font-oswald-bold h-[70px] w-[300px] bg-white text-center text-[18px] leading-[70px] shadow-xl'
            onClick={handleOpen}
          >
                        SIGN IN
          </button>
        </div>}
      </div>
    </div>
  }


  function BannerMobile() {
    return <div className=''>
      <Image src={"/refer-a-friend/banner_m.webp"}
        width={375}
        height={220}
        alt='Refer a Friend'
        className='mx-auto w-full'
      />

      {isSignedIn ? <div className='px-[16px]'>
        <p className='font-oswald-bold text-primary mt-[30px] text-[20px]'>
                    Welcome Back, {firstname || "Customer"}
        </p>

        <p className='text-primary mt-[10px] text-sm'>
                    Quick Action:  <span onClick={handleClick} className='text-primary cursor-pointer underline'>My Reward Codes</span>
        </p>
      </div> : <div className='mx-[15px] mt-[30px] flex flex-col justify-between  gap-[15px]'>
        <button
          className='bg-primary font-oswald-bold lg_text-[18px] h-[45px] w-full text-center text-sm leading-[45px]  text-white shadow-xl'
          onClick={handleOpenCreateAccount}
        >
                    JOIN NOW!
        </button>

        <button
          className='text-primary font-oswald-bold lg_text-[18px] border-1 border-primary lg_border-none lg_shadow-xl h-[45px] w-full border-solid bg-white text-center text-sm leading-[45px]'
          onClick={handleOpen}
        >
                    SIGN IN
        </button>
      </div>}
    </div>
  }


  return <div>
    {isMobile ? <BannerMobile /> : <BannerPC />}
    <div className='lg_mx-auto lg_mt-[80px] mt-[40px] w-full max-w-[1440px] px-[15px]'>
      <h2 className='lg_text-center font-oswald-bold lg_text-[44px] text-left text-[20px]'>How It Works</h2>
      <p className='lg_mt-[60px] lg_text-[22px] mt-[30px] text-sm'>Love our products? Share the love with your friends and family!</p>

      {isMobile ? <MainMobile /> : <MainPC />}

    </div>

    <div ref={placeholderRef} />

    <div className='lg_mt-[40px] mt-[40px] bg-[#f8f8f8]'>
      <div className='lg_pb-[80px] mx-auto w-full max-w-[1440px] px-[15px] pb-3'>
        <h2 className='lg_text-center text-primary font-oswald-bold lg_text-[44px] lg_pt-[80px] pt-[12px] text-left text-[20px] '>My Reward Codes</h2>
        {isMobile ? <MyRewardMobile couponCodesArray={couponCodesArray} /> : <MyRewardPC couponCodesArray={couponCodesArray} />}
      </div>
    </div>

    <div className='lg_px-[0px] lg_mx-auto w-full max-w-[1440px] px-[15px] pb-[80px]'>
      <h2 className='lg_text-center font-oswald-bold lg_text-[44px] text-primary lg_pt-[80px] lg_pb-[60px] pb-[30px] pt-[40px]   text-left text-[20px]'>Frequently Asked Questions</h2>

      <ul className='lg_gap-[80px] flex flex-col gap-[20px]'>
        {[
          {
            question: "How much discount can I make?",
            answer: 'The maximum reward discounts that you can make are 5 * 10% off. It means you can earn 5 "10% off discount" codes as rewards by inviting 5 people to join HISEA and take orders.'
          },
          {
            question: "Can I refer a friend through social media?",
            answer: 'Yes, you can. In "My Account", "Referral Program" section, there are some referral pathways as inviting using social media buttons. You can also send an email with referral link or directly copy the referral link to your friend.'
          },
        ].map((item, index) => {
          return <li key={index}>
            <div className='font-oswald-bold lg_text-[18px] text-primary text-[16px]'>{item.question}</div>
            <div className='font-urw-din-medium lg_text-[18px] text-primary mt-[10px] text-sm leading-[26px]'>{item.answer}</div>
          </li>
        })}
      </ul>
    </div>
  </div>
}

;

// const couponCodesArray = [
//     {
//         discountCode: 'HSM2301',
//         discounts: '10% Off',
//         availableDate: '01/20/2024',
//         validDate: '07/20/2024',
//         status: 'Valid',
//         order: 1
//     },
//     {
//         discountCode: 'HSM2301',
//         discounts: '10% Off',
//         availableDate: '01/20/2024',
//         validDate: '07/20/2024',
//         status: 'Valid',
//         order: 2
//     },
//     {
//         discountCode: 'HSM2301',
//         discounts: '10% Off',
//         availableDate: '01/20/2024',
//         validDate: '07/20/2024',
//         status: 'Valid',
//         order: 3
//     },
// ];

function MyRewardMobile({
  couponCodesArray 
}) {
  const [, {
    addToast 
  }] = useToasts()

  const router = useRouter()

  if (!couponCodesArray) {
    return <div className='lg_text-[16px] text-primary font-urw-din-medium mt-[30px] text-sm'>
            You do not have any reward codes, refer more people now to codes for you!
    </div>
  }

  if (Array.isArray(couponCodesArray) && couponCodesArray.length === 0) {
    return <div className='lg_text-[16px] text-primary font-urw-din-medium mt-[30px] text-sm'>
            You do not have any reward codes, refer more people now to codes for you!
    </div>
  }


  return <div className='mt-[30px]'>
    <ul className='flex flex-col gap-[10px]'>
      {couponCodesArray.map((item, index) => {
        return <li className='border-1 border-[#ccc] p-[9px] pt-[5px]' key={index}>
          <div className='border-b-1 flex h-[45px] items-center justify-between border-solid border-[#ccc]'>
            <span className='font-urw-din-medium text-4 text-primary font-bold'>Discount Code: {item.code}</span>
            <button
              onClick={() => {
                copy(item.code);


                addToast({
                  type: "success",
                  message: "copied",
                  timeout: 1000,
                })
              }}

              className='bg-primary font-oswald-bold h-[30px] w-[100px] text-sm uppercase leading-[30px] text-white '


            >Copy</button>
          </div>

          <div className='text-primary flex flex-col gap-1'>
            <div className='flex justify-between'>
              <div>Discounts:</div>
              <div>{item.amount}</div>
            </div>
            <div className='flex justify-between'>
              <div>Available Date:</div>
              <div>{item.from_date}</div>
            </div>
            <div className='flex justify-between'>
              <div>Valid Date:</div>
              <div>{item.to_date}</div>
            </div>
            <div className='flex justify-between'>
              <div>Status:</div>
              <div>{item.type === 1 ? "Valid" : "Invalid"}</div>
            </div>
            <div className='flex justify-between'>
              <div>Order:</div>
              <div>
                {item.order_id === 0 ? "" : <span
                  className='font-oswald-bold text-primary cursor-pointer text-sm underline'
                  onClick={() => { router.push("/track-your-order/") }}
                >View Order</span>}
              </div>
            </div>
          </div>
        </li>
      })}
    </ul>
  </div>
}

function MyRewardPC({
  couponCodesArray 
}) {
  const [, {
    addToast 
  }] = useToasts()
  const router = useRouter()


  if (!couponCodesArray) {
    return <div className='lg_text-[16px] text-primary font-urw-din-medium mt-[10px] text-center text-sm'>
            You do not have any reward codes, refer more people now to codes for you!
    </div>
  }

  if (Array.isArray(couponCodesArray) && couponCodesArray.length === 0) {
    return <div className='lg_text-[16px] text-primary font-urw-din-medium mt-[10px]  text-center text-sm'>
            You do not have any reward codes, refer more people now to codes for you!
    </div>
  }


  return (
    <div className='lg_pt-[60px] mx-auto'>
      <div>
        <ul className='bg-primary flex justify-center text-center text-white'>
          <li className='w-[300px] py-[16px]'>Discount Code</li>
          <li className='w-[200px] py-[16px]'>Discounts</li>
          <li className='w-[200px] py-[16px]'>Available Date</li>
          <li className='w-[200px] py-[16px]'>Valid Date</li>
          <li className='w-[200px] py-[16px]'>Status</li>
          <li className='w-[200px] py-[16px]'>Order</li>
        </ul>
      </div>
      <div className='mt-[10px] flex flex-col gap-[10px]'>
        {couponCodesArray.map((row, index) => (
          <ul key={index} className='flex h-[70px] justify-center bg-white text-center leading-[70px]'>
            <li className='flex w-[300px] items-center justify-center gap-[18px]'>
              <span>{row.code}</span>
              <button className='mybutton bg-primary font-oswald-bold h-[30px] w-[100px] uppercase leading-[30px] text-white'
                onClick={() => {
                  copy(row.code);
                  addToast({
                    type: "success",
                    message: "copied",
                    timeout: 1000,
                  })

                }}
              >copy</button>
            </li>
            <li className='w-[200px]'>{row.amount}</li>
            <li className='w-[200px]'>{row.from_date}</li>
            <li className='w-[200px]'>{row.to_date}</li>
            <li className='w-[200px]'>{row.type === 1 ? "Valid" : "Invalid"}</li>
            <li className='font-oswald-bold text-primary w-[200px] cursor-pointer underline'>
              {row.order_id === 0 ? "" : <span
                onClick={() => { router.push("/track-your-order/") }}
              >View Order</span>}
            </li>
          </ul>
        ))}
      </div>
    </div>
  );
}

export default ReferAFriendPage;


